import api from '@/lib/api/axios'
import type { Job, JobRun, ListParams, PaginatedResponse } from '@/lib/api/types'

export const jobsApi = {
    list: (params?: ListParams) =>
        api.get<PaginatedResponse<Job>>('/api/jobs', { params }),

    get: (id: number) =>
        api.get<Job>(`/api/jobs/${id}`),

    create: (data: Omit<Job, 'id' | 'createdAt' | 'updatedAt' | 'lastRun' | 'nextRun' | 'status'>) =>
        api.post<Job>('/api/jobs', data),

    update: (id: number, data: Partial<Omit<Job, 'id' | 'createdAt' | 'updatedAt' | 'lastRun' | 'nextRun' | 'status'>>) =>
        api.put<Job>(`/api/jobs/${id}`, data),

    delete: (id: number) =>
        api.delete(`/api/jobs/${id}`),

    // Job execution
    run: (id: number) =>
        api.post<JobRun>(`/api/jobs/${id}/run`),

    pause: (id: number) =>
        api.post<void>(`/api/jobs/${id}/pause`),

    resume: (id: number) =>
        api.post<void>(`/api/jobs/${id}/resume`),

    // Job runs
    getRuns: (id: number, params?: ListParams) =>
        api.get<PaginatedResponse<JobRun>>(`/api/jobs/${id}/runs`, { params }),

    getLogs: (id: number, runId: number) =>
        api.get<{ logs: string }>(`/api/jobs/${id}/runs/${runId}/logs`),
}



